import React, { useEffect, useState } from "react";
import { ChannelUserService } from "../../services/ChannelUserService";
import { ChannelPlanModel, ChannelPlanStatus, mapToNeWChannelPlanModel, NewChannelPlanModel, ValidityType } from "../../models/users.model";
import PlanContainerComponent from "./plan-container.component";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonComponent from "../shared/button/button.component";
import { AppRoutes } from "../routes/route.path";
import { Dialog, DialogContent, DialogTitle, LinearProgress } from "@mui/material";
import { FalkonchatIcon, PaymentFailedIcon, PaymentFailureIcon, SuccessIcon } from "../../icon";
import { buttonLabels } from "../shared/constants";
import { CancelDeleteChatIcon, CancelIcon } from "../../icon";
import AvatarLoaderComponent from "../shared/loaders/animate-loader.component";
import ProductLoader from "../shared/loaders/product-loader.json";
import { ChannelAuthService } from "../../services/ChannelAuthService";
import * as selector from "../../selectors/selectors";
import { useDispatch, useSelector } from "react-redux";
import { LoadChannelPlans } from "../../actions";
interface IProps {
    CurrentPlan?: ChannelPlanModel,
    handleChangePlan?: () => void;
}


const ChannelSelectPlanComponent: React.FC<IProps> = (Props: IProps) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [products, setProducts] = useState<NewChannelPlanModel[]>()
    const [planValidity, setPlanValidity] = useState<string>(ValidityType.MONTHLY)
    const [show, setShow] = useState<boolean>(false)
    const [loadingProducts, setLoadingProducts] = useState<boolean>(false)

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);

    const PlanDetails: ChannelPlanModel = useSelector(selector.PlanDetails);

    const params = new URLSearchParams(location.search);
    const dispatch = useDispatch();

    const success = params.get("success");
    const cancel = params.get("canceled");


    useEffect(() => {
        setLoadingProducts(true)
        ChannelUserService.getAllPlans().then((res) => {
            const data = res.data.map(x => x.prices.map((y, index) => mapToNeWChannelPlanModel(x, y)))
            setProducts(data.flatMap(x => x))
            LoadChannelPlans(dispatch)
            setLoadingProducts(false)
        })
    }, [])


    const handlePlanSelect = (plan: NewChannelPlanModel) => {
        setProducts(products?.map(x => (plan.Name === x.Name && plan.Type === x.Type) ? { ...plan, Selected: true } : { ...x, Selected: false, Quantity: 1 }))
    }

    const handlePlanValidity = (value) => {
        setPlanValidity(value)
        setProducts(products?.map(x => { return { ...x, Selected: false, Quantity: 1 } }))
    }

    useEffect(() => {
        if (success === "true") {
            setShow(true)
            setTimeout(() => {
                navigate(AppRoutes.CHANNELS_DASHBOARD)
            }, 1500);
        }
    }, [success])

    const handlePaymentFailedTryAgain = () => {
        const hasExistingPlan =
            !!Props.CurrentPlan ||
            (PlanDetails?.Status != null && PlanDetails.Status !== ChannelPlanStatus.NO_PLAN);
        navigate(
            (hasExistingPlan || location.pathname === AppRoutes.CHANNELS_PLANS) ? AppRoutes.CHANNELS_PLANS : AppRoutes.SELECT_PLAN,
            { replace: true }
        );
    }

    return (
        <div className="w-p-100 h-p-100 d-flex align-center justify-center p-relative">
            {IsMobileDevice && Props.CurrentPlan && <CancelDeleteChatIcon className="w-2 h-2 c-pointer p-absolute t-2 r-2" onClick={Props.handleChangePlan} />}
            <div className={`w-p-98 h-p-98 m-auto ${IsMobileDevice && "o-y-scroll"}`}>
                <div className={`w-p-100 d-flex justify-center align-center ${IsMobileDevice ? "flex-direction h-24" : "h-p-17"}`}>
                    {!IsMobileDevice && <div className="w-30 d-flex justify-center align-center">
                        {(!Props.CurrentPlan || PlanDetails.Status === ChannelPlanStatus.NO_PLAN) && <FalkonchatIcon className="" />}
                    </div>
                    }
                    <div className="flex-1 h-p-100 d-flex flex-direction justify-center">
                        <div className="t-align-center h2-semibold color-primary-accent">Choose Your Plan</div>
                        <div className="t-align-center color-plans-secondary-text-color h5-medium mb-3 w-p-80 mx-auto">Select the perfect plan for your team and complete your purchase</div>
                        <div className="bb-display-background-4 w-p-70 mx-auto"></div>
                    </div>
                    {
                        (!IsMobileDevice || (IsMobileDevice && !Props.CurrentPlan)) && <div className="w-30 d-flex justify-center align-center">
                            {Props.CurrentPlan ?
                                <CancelDeleteChatIcon className="w-4 h-4 c-pointer" onClick={Props.handleChangePlan} />
                                :
                                (PlanDetails?.Status === null || PlanDetails.Status === ChannelPlanStatus.NO_PLAN) && <ButtonComponent ButtonLabel="Sign Out" Variant="primary-btn" ClassName="c-pointer" OnClick={ChannelAuthService.logout} ></ButtonComponent>
                            }
                        </div>
                    }
                </div>

                <div className={`d-flex justify-center mx-auto ${IsMobileDevice ? "h-6 my-1" : "h-p-8"}`}>
                    <div className="d-flex justify-center align-center h-5 profile-border br-2 h5-medium w-18">
                        <div onClick={() => handlePlanValidity(ValidityType.MONTHLY)} className={`${planValidity === ValidityType.MONTHLY ? "bg-color-primary-link color-secondary" : "color-plans-secondary-text-color"} h-4 w-9 d-flex justify-center align-center br-2 c-pointer`}>
                            Monthly
                        </div>
                        <div onClick={() => handlePlanValidity(ValidityType.YEARLY)} className={`${planValidity === ValidityType.YEARLY ? "bg-color-primary-link color-secondary" : "color-plans-secondary-text-color"} h-4 w-8 d-flex justify-center align-center br-2 c-pointer`}>
                            Yearly
                        </div>
                    </div>
                </div>
                <div className={`${IsMobileDevice ? "" : "h-p-75 o-y-scroll"}`}>
                    <div className="mt-2 d-flex flex-wrap w-p-90 mx-auto justify-center">
                        {loadingProducts ?

                            [1, 2, 3].map(x => {
                                return <div className={`w-40 m-2 p-relative`}>
                                    <AvatarLoaderComponent LoaderAnimation={ProductLoader} />
                                </div>
                            })

                            :
                            products?.filter(x => (x.Type === planValidity || x.Type === ValidityType.ONETIME)).sort((a, b) => a.Price - b.Price).map(x => (
                                <PlanContainerComponent Plan={{ ...x, Quantity: Props.CurrentPlan ? x.Quantity < Props.CurrentPlan.Quantity ? Props.CurrentPlan.Quantity : x.Quantity : x.Quantity }} HandlePlanSelect={handlePlanSelect} CurrentPlan={Props.CurrentPlan} />
                            ))
                        }
                    </div>
                </div>
            </div>
            {show &&
                <Dialog open={show} >
                    <DialogContent className="px-0">
                        <div className="d-flex flex-direction align-center">
                            <div className="p-2 br-50"> <SuccessIcon /></div>
                            <span className="h2-semibold my-1">
                                Payment Successful!
                            </span>
                            <span className="h4-medium my-2 w-p-70 t-align-center color-plans-secondary-text-color">Your payment has been processed successfully. Redirecting to your dashboard...</span>
                            {/* <div className="h-1 br-5 bg-color-plans-secondary-text-color w-p-70 my-2">
                                <div className="h-1 br-5 bg-color-primary-success w-p-35"></div>
                            </div> */}
                            <div className="w-p-70 my-4">
                                <LinearProgress color="success" /></div>
                        </div>
                    </DialogContent>
                </Dialog>
            }

            {
                <Dialog open={cancel === "true"} >
                    <DialogContent className="px-0">
                        <div className="d-flex flex-direction align-center">
                            <div className="p-2 br-50"><PaymentFailureIcon className="w-12 h-12" /></div>
                            <span className="h2-semibold">
                                Payment Failed
                            </span>
                            <span className="h4-medium w-p-70 t-align-center color-plans-secondary-text-color">There was an issue processing your payment. Please check your payment details and try again.</span>
                            <ButtonComponent ButtonLabel={buttonLabels.TRY_AGAIN} Variant={"primary-btn"} OnClick={handlePaymentFailedTryAgain} />
                        </div>
                    </DialogContent>
                </Dialog>
            }
        </div>
    )
}

export default ChannelSelectPlanComponent;